module.exports = __webpack_public_path__ + "img/1-2.2ca92e13.jpg";